// You can write more code here

/* START OF COMPILED CODE */

import UIBlocker from "../GeneralUI/UIBlocker";
import DefaultButton from "../GeneralUI/Buttons/DefaultButton";
import DefaultConfirmButton_m from "../DefaultConfirmButton_m";
/* START-USER-IMPORTS */
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { CutsceneData } from '@/game/GameComponents/PhaserGame/Tutorialization/TutorializationManager';
import { getAnchorPlugin } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
/* END-USER-IMPORTS */

export default class MentorDialoguePanel extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// desktopView
		const desktopView = scene.add.container(0, 0);
		desktopView.visible = false;
		this.add(desktopView);

		// backdrop
		const backdrop = scene.add.image(504, 368, "forest-background");
		backdrop.scaleX = 5;
		backdrop.scaleY = 5;
		desktopView.add(backdrop);

		// uIBlocker
		const uIBlocker = new UIBlocker(scene, 0, 0);
		desktopView.add(uIBlocker);

		// mainContainer
		const mainContainer = scene.add.container(512, 768);
		desktopView.add(mainContainer);

		// greenleaf
		const greenleaf = scene.add.image(176, -296, "npc_mentor_e_portrait");
		greenleaf.scaleX = 0.4;
		greenleaf.scaleY = 0.4;
		mainContainer.add(greenleaf);

		// dialogueBacking
		const dialogueBacking = scene.add.nineslice(0, -176, "Hud1", undefined, 160, 64, 8, 8, 8, 8);
		dialogueBacking.scaleX = 4;
		dialogueBacking.scaleY = 4;
		mainContainer.add(dialogueBacking);

		// headerBacking
		const headerBacking = scene.add.nineslice(-304, -304, "Hud2", undefined, 80, 16, 4, 4, 4, 8);
		headerBacking.scaleX = 4;
		headerBacking.scaleY = 4;
		headerBacking.setOrigin(0, 0.5);
		mainContainer.add(headerBacking);

		// speaker_name
		const speaker_name = scene.add.bitmapText(-288, -304, "Aronui", "Guardian Greenleaf");
		speaker_name.setOrigin(0, 0.5);
		speaker_name.tintTopLeft = 985612;
		speaker_name.tintTopRight = 985612;
		speaker_name.tintBottomLeft = 985612;
		speaker_name.tintBottomRight = 985612;
		speaker_name.text = "Guardian Greenleaf";
		speaker_name.fontSize = -30;
		mainContainer.add(speaker_name);

		// dialogue_text
		const dialogue_text = scene.add.bitmapText(-288, -248, "Aronui", "Welcome spellcaster to my realm! Today we are going to be learning about phonemes.");
		dialogue_text.tintTopLeft = 5387071;
		dialogue_text.tintTopRight = 5387071;
		dialogue_text.tintBottomLeft = 5387071;
		dialogue_text.tintBottomRight = 5387071;
		dialogue_text.text = "Welcome spellcaster to my realm! Today we are going to be learning about phonemes.";
		dialogue_text.fontSize = -22;
		dialogue_text.maxWidth = 600;
		mainContainer.add(dialogue_text);

		// nextLineButton
		const nextLineButton = new DefaultButton(scene, 200, -96);
		mainContainer.add(nextLineButton);

		// mobileView
		const mobileView = scene.add.container(0, 0);
		this.add(mobileView);

		// backdrop_m
		const backdrop_m = scene.add.image(336, 192, "forest-background");
		backdrop_m.scaleX = 5;
		backdrop_m.scaleY = 5;
		mobileView.add(backdrop_m);

		// uIBlocker_m
		const uIBlocker_m = new UIBlocker(scene, 0, 0);
		mobileView.add(uIBlocker_m);

		// mainContainer_m
		const mainContainer_m = scene.add.container(339, 376);
		mobileView.add(mainContainer_m);

		// greenleaf_m
		const greenleaf_m = scene.add.image(181, -16, "npc_mentor_e_portrait");
		greenleaf_m.scaleX = 0.4;
		greenleaf_m.scaleY = 0.4;
		mainContainer_m.add(greenleaf_m);

		// dialogueBacking_m
		const dialogueBacking_m = scene.add.nineslice(0, -96, "Hud1", undefined, 302, 90, 8, 8, 8, 8);
		dialogueBacking_m.scaleX = 2;
		dialogueBacking_m.scaleY = 2;
		mainContainer_m.add(dialogueBacking_m);

		// dialogue_text_m
		const dialogue_text_m = scene.add.bitmapText(-286, -152, "Aronui", "Welcome spellcaster to my realm! Today we are going to be learning about phonemes.");
		dialogue_text_m.tintTopLeft = 5387071;
		dialogue_text_m.tintTopRight = 5387071;
		dialogue_text_m.tintBottomLeft = 5387071;
		dialogue_text_m.tintBottomRight = 5387071;
		dialogue_text_m.text = "Welcome spellcaster to my realm! Today we are going to be learning about phonemes.";
		dialogue_text_m.fontSize = -20;
		dialogue_text_m.maxWidth = 550;
		mainContainer_m.add(dialogue_text_m);

		// headerContainer
		const headerContainer = scene.add.container(-295, -184);
		mainContainer_m.add(headerContainer);

		// headerBacking_m
		const headerBacking_m = scene.add.nineslice(0, 0, "Hud2", undefined, 160, 24, 4, 4, 4, 8);
		headerBacking_m.scaleX = 2;
		headerBacking_m.scaleY = 2;
		headerBacking_m.setOrigin(0, 0.5);
		headerContainer.add(headerBacking_m);

		// speaker_name_m
		const speaker_name_m = scene.add.bitmapText(14, 0, "Aronui", "Guardian Greenleaf");
		speaker_name_m.setOrigin(0, 0.5);
		speaker_name_m.tintTopLeft = 985612;
		speaker_name_m.tintTopRight = 985612;
		speaker_name_m.tintBottomLeft = 985612;
		speaker_name_m.tintBottomRight = 985612;
		speaker_name_m.text = "Guardian Greenleaf";
		speaker_name_m.fontSize = -24;
		headerContainer.add(speaker_name_m);

		// nextLineButton_m
		const nextLineButton_m = new DefaultConfirmButton_m(scene, 192, -44);
		mainContainer_m.add(nextLineButton_m);

		// nextLineButton (prefab fields)
		nextLineButton.buttonText = "Next";

		// nextLineButton_m (prefab fields)
		nextLineButton_m.buttonText = "OK";

		this.backdrop = backdrop;
		this.greenleaf = greenleaf;
		this.dialogue_text = dialogue_text;
		this.nextLineButton = nextLineButton;
		this.mainContainer = mainContainer;
		this.desktopView = desktopView;
		this.backdrop_m = backdrop_m;
		this.greenleaf_m = greenleaf_m;
		this.dialogue_text_m = dialogue_text_m;
		this.nextLineButton_m = nextLineButton_m;
		this.mainContainer_m = mainContainer_m;
		this.mobileView = mobileView;

		/* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
	}

	private backdrop: Phaser.GameObjects.Image;
	public greenleaf: Phaser.GameObjects.Image;
	public dialogue_text: Phaser.GameObjects.BitmapText;
	public nextLineButton: DefaultButton;
	private mainContainer: Phaser.GameObjects.Container;
	public desktopView: Phaser.GameObjects.Container;
	private backdrop_m: Phaser.GameObjects.Image;
	public greenleaf_m: Phaser.GameObjects.Image;
	public dialogue_text_m: Phaser.GameObjects.BitmapText;
	public nextLineButton_m: DefaultConfirmButton_m;
	private mainContainer_m: Phaser.GameObjects.Container;
	public mobileView: Phaser.GameObjects.Container;

	/* START-USER-CODE */
  private currentSlideIndex: number = -1;
  private cutsceneData: CutsceneData | null = null;
  onDialogueComplete?: () => void;
  currentDialogue?: Phaser.Sound.HTML5AudioSound;
  private hasInitialized: boolean = false;

  init(dialogueData: any) {
    if (this.hasInitialized) return;
    this.setVisible(true);
    this.hasInitialized = true;
    this.cutsceneData = dialogueData;
    this.currentSlideIndex = -1;
    this.getResponsiveElements('nextLineButton').forEach(
      (nextLineButton: DefaultButton) => {
        nextLineButton.controller.setSubmissionCallback(() => {
          this.handleUserRequestedNextLine();
        });
      },
    );

    this.showNextLine();
    this.setDepth(9999);

    this.initializeResponsiveness();
  }

  getResponsiveElements(key: keyof MentorDialoguePanel) {
    return ResponsivenessManager.GetAllResponsiveComponentsFromContainer(
      this,
      key,
    );
  }

  setCutsceneData(cutsceneData: CutsceneData) {
    this.cutsceneData = cutsceneData;
    this.showNextLine();
  }

  showNextLine() {
    if (!this.cutsceneData) return;
    if (this.currentDialogue) {
      this.currentDialogue.stop();
    }
    this.currentSlideIndex++;

    const slide = this.cutsceneData.slides[this.currentSlideIndex];
    this.getResponsiveElements('dialogue_text').forEach(
      (text: Phaser.GameObjects.BitmapText) => {
        text.setText(slide.mainText);
      },
    );

    if (slide.audioKey) {
      const sound = this.scene.sound.add(slide.audioKey);
      this.currentDialogue = sound as Phaser.Sound.HTML5AudioSound;
      sound.play();
    }

    this.setVisible(true);
  }

  overrideMentor(newMentor: string) {
    this.getResponsiveElements('greenleaf').forEach(
      (mentorImage: Phaser.GameObjects.Image) => {
        mentorImage.setTexture(newMentor);
      },
    );
  }

  handleUserRequestedNextLine() {
    if (!this.cutsceneData) return;
    if (this.currentSlideIndex < this.cutsceneData?.slides.length - 1) {
      this.showNextLine();
    } else {
      this.onDialogueComplete?.();
      this.setVisible(false);
    }
  }

  initializeResponsiveness() {
    ResponsivenessManager.InitializeResponsiveBreakpoints({
      scene: this.scene,
      desktopView: this.desktopView,
      mobileView: this.mobileView,
    });

    // Desktop.
    const anchor = getAnchorPlugin(this.scene);
    anchor.add(this.mainContainer, {
      centerX: '50%',
      bottom: '100%',
    });
    anchor.add(this.backdrop, {
      centerX: '50%',
      centerY: '50%',
    });

    // Mobile.
    anchor.add(this.mainContainer_m, {
      centerX: '50%',
      bottom: '100%-16',
    });
    anchor.add(this.backdrop_m, {
      centerX: '50%',
      centerY: '50%',
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
